import React, { useState } from 'react';
import { Col, Container, Row, Form } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
import { useForm } from 'react-hook-form';
import axios from "axios";
import { toast } from "react-toastify";
import Testimonials from '../Testimonials';
import Loader from '../Loader';

const Register = () => {
  const { register, handleSubmit, formState: {errors}, reset } = useForm({ defaultValues: { firstName:"", lastName:"", phone:"", email:"", country:"", password:"", terms:"" } });
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const handleRegister = async (data) => {
    const userName = `${data.firstName?.trim()} ${data.lastName}`;
    setLoader(true);
    axios({
      method:"POST",
      url:`${process.env.REACT_APP_BASE_URL}/user`,
      headers: {
        "Content-Type":"application/json"
      },
      data: JSON.stringify({
        userName: userName,
        email: data.email,
        country: data.country,
        password: data.password,
        phone: data.phone
      }),
    })
    .then(res => {
      setLoader(false);
      reset({ firstName:"", lastName:"", country:"", email:"", password:"", phone:"", terms:"" });
      toast(res.data.message, {
        theme:'light',
        type:'success',
        position:'top-right'
      });
      navigate('/login');
    })
    .catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors?.[0]?.msg, {
          theme: 'light',
          type:'error',
          position: 'top-right'
        });
      } else {
        return toast(err?.response?.data?.message || err?.message || "Register unsuccessful. The server is not responding.", {
          theme: 'light',
          type:'error',
          position: 'top-right'
        })
      }
    });
  }
  return (
    <>
      <section className='form-section register'>
        <Container>
          <Row className="justify-content-center">
            <Col xxl={6} md={8} sm={10}>
              <div className="boxwrap">
                <h2 className='text-gradient'>Register</h2>
                <p className="mb-3">Enter the login information for your account. You will be able to create additional users after registering.</p>
                <Form onSubmit={handleSubmit(handleRegister)} className="row">
                  <Form.Group as={Col} md="6" className="mb-3" controlId="register-firstname">
                    <Form.Label>First name <span>*</span></Form.Label>
                    <Form.Control
                      type="text" placeholder='Enter your first name'
                      {...register("firstName",
                        {
                          required: {message:"First name is require", value:true},
                          minLength: { message: "First name is not valid", value:2 }
                        }
                      )}/>
                      { errors.firstName ? <p className="errMsg">{errors.firstName.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} md="6" className="mb-3" controlId="register-Lastname">
                    <Form.Label>Last name <span>*</span></Form.Label>
                    <Form.Control
                      type="text" placeholder='Enter your last name'
                      {...register("lastName",
                        {
                          required: { message:"Last name is require", value:true },
                          minLength: { message:"Last name is not valid", value:2 }
                        }
                      )}/>
                    { errors.lastName ? <p className="errMsg">{errors.lastName.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} md="6" className="mb-3" controlId="register-phone">
                    <Form.Label>Phone <span>*</span></Form.Label>
                    <Form.Control
                      type="tel" placeholder='Enter your phone number'
                      {...register("phone",
                        {
                          required: { message:"Phone number is require", value:true },
                          pattern: { message:'Phone number is not valid', value:/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/g }
                        }
                      )}/>
                    { errors.phone ? <p className="errMsg">{errors.phone.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} md="6" className="mb-3" controlId="register-email">
                    <Form.Label>Email address <span>*</span></Form.Label>
                    <Form.Control
                      type="email" placeholder='Enter your email address'
                      {...register("email",
                        {
                          required: { message:"E-Mail is require", value:true },
                          pattern: { message: 'E-Mail is not valid', value:/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g } 
                        }
                      )}/>
                    { errors.email ? <p className="errMsg">{errors.email.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="mb-3" controlId="register-country">
                    <Form.Label>Country <span>*</span></Form.Label>
                    <Form.Control
                      type="text" placeholder='Enter your country name'
                      {...register("country",
                        {
                          required: { message:"Country name is require", value:true },
                        }
                      )}/>
                    { errors.country ? <p className="errMsg">{errors.country.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="mb-3" controlId="register-password">
                    <Form.Label>Password <span>*</span></Form.Label>
                    <Form.Control
                      type="password" placeholder='Enter your password'
                      {...register("password", {
                        required: { message:"Password is require", value:true },
                        pattern: { message:"Password is too weak", value: /^(?=.*\d)(?=.*[a-zA-Z]).{6,}$/g }
                      })}/>
                    { errors.password ? <p className="errMsg">{errors.password.message}</p> : null }
                    <Form.Text className="form-text">
                      Your password must be 6 characters long, contain letters, numbers and special characters.
                    </Form.Text>
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="mb-3">
                    <Form.Check
                      id='privacy-policy-checkbox'
                      className='d-flex align-items-center gap-2'
                      label={<label htmlFor='privacy-policy-checkbox'>I Agree to <Link to="/termsofservice">terms and conditions</Link>.</label>}
                      {...register("terms", {
                        required: { message:"Terms and conditions is require", value:true }
                      })}/>
                    { errors.terms ? <p className="errMsg">{errors.terms.message}</p> : null }
                  </Form.Group>
                  <div className="mb-4">
                    <button type="submit" className="button blue w-100 py-3">Submit</button>
                  </div>																
                  <div className="col-md-12 mt-3">
                    <p className='mb-0'>Already have an account ? <Link to="/login">Sign in</Link></p>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Testimonials />
      <Loader show={loader}/>
    </>
  )
}

export default Register